// src/TemperatureHumidityChart.js
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
 
const data1 = [
  {
    "time": "01-Dec",
    "avg_temperature": 22,
    "avg_humidity": 19
  },
  {
    "time": "25-Nov",
    "avg_temperature": null,
    "avg_humidity": null
  },
  {
    "time": "26-Nov",
    "avg_temperature": null,
    "avg_humidity": null
  },
  {
    "time": "27-Nov",
    "avg_temperature": 28,
    "avg_humidity": 23
  },
  {
    "time": "28-Nov",
    "avg_temperature": 23,
    "avg_humidity": 27
  },
  {
    "time": "29-Nov",
    "avg_temperature": 23,
    "avg_humidity": 26
  },
  {
    "time": "30-Nov",
    "avg_temperature": 22,
    "avg_humidity": 22
  }
];

const data2 = [
  {
      "time": "00:00",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "00:30",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "01:00",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "01:30",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "02:00",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "02:30",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "03:00",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "03:30",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "04:00",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "04:30",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "05:00",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "05:30",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "06:00",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "06:30",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "07:00",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "07:30",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "08:00",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "08:30",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "09:00",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "09:30",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "10:00",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "10:30",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "11:00",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "11:30",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "12:00",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "12:30",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "13:00",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "13:30",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "14:00",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "14:30",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "15:00",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "15:30",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "16:00",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "16:30",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "17:00",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "17:30",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "18:00",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "18:30",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "19:00",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "19:30",
      "avg_pm_2_5": 122,
      "avg_pm_10": 125,
      "avg_mk_0_3": 17784,
      "avg_mk_0_5": 5542,
      "avg_mk_1_0": 1194,
      "avg_mk_2_5": 91,
      "avg_mk_5_0": 3,
      "avg_mk_10": 0
  },
  {
      "time": "20:00",
      "avg_pm_2_5": 127,
      "avg_pm_10": 130,
      "avg_mk_0_3": 18673,
      "avg_mk_0_5": 5797,
      "avg_mk_1_0": 1271,
      "avg_mk_2_5": 88,
      "avg_mk_5_0": 2,
      "avg_mk_10": 0
  },
  {
      "time": "20:30",
      "avg_pm_2_5": 129,
      "avg_pm_10": 132,
      "avg_mk_0_3": 18676,
      "avg_mk_0_5": 5830,
      "avg_mk_1_0": 1320,
      "avg_mk_2_5": 89,
      "avg_mk_5_0": 4,
      "avg_mk_10": 0
  },
  {
      "time": "21:00",
      "avg_pm_2_5": 128,
      "avg_pm_10": 133,
      "avg_mk_0_3": 18891,
      "avg_mk_0_5": 5890,
      "avg_mk_1_0": 1285,
      "avg_mk_2_5": 94,
      "avg_mk_5_0": 6,
      "avg_mk_10": 0
  },
  {
      "time": "21:30",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "22:00",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "22:30",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "23:00",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  },
  {
      "time": "23:30",
      "avg_pm_2_5": null,
      "avg_pm_10": null,
      "avg_mk_0_3": null,
      "avg_mk_0_5": null,
      "avg_mk_1_0": null,
      "avg_mk_2_5": null,
      "avg_mk_5_0": null,
      "avg_mk_10": null
  }
]


const CustomLegend = (props) => {
  const { payload } = props;
  return (
    <div style={{ textAlign: 'center', fontSize: '14px', color: '#555', marginLeft: "1rem" }}>
      {payload.map((entry, index) => (
        <span key={index} style={{ marginRight: 10, fontWeight: 'bold' }}>
          <span style={{ color: entry.color }}>●</span> {entry.value}
        </span>
      ))}
    </div>
  );
};

const color = [
  "#60DC32","#ff6200","#0B3D82","#FF853A","#3BDA00","#0F4FA8","#FF6200","#2EA900","#000000","#C64C00","#248500","#072F66","#9B3B00"
]

const keysData = (data) =>{

    if (!data.length) return <></>
      
    return  Object.entries(data[0]).map(([key, value], index) =>{
        if (key !== "time") return <Line type="monotone" key={index} dataKey={key} stroke={color[index]} />
    })
}

const TemperatureHumidityChart = (props) => {
  //const data = data2


  const {data} = props
  //console.log(data)
  return (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'left', marginLeft: "-2rem" }}>
      <ResponsiveContainer width="90%" aspect={2}>
        <LineChart data={data} >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="time" />
          <YAxis />
          <Tooltip />
          <Legend content={<CustomLegend />} />
          
          {keysData(data)}
          {/* <Line type="monotone" dataKey="avg_pm_2_5" stroke="#ff6200" />
          <Line type="monotone" dataKey="avg_pm_10" stroke="#005cbf" /> */}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
 
export default TemperatureHumidityChart;